export const ERRORS = {
  CODE_UNAUTHENTICATED: -401,
} as const;
